import moment from "moment";

export default class DateService {

    apiDateToMoment(apiDate) {
        return moment(apiDate);
    }

    getMoment(year, month, day) {
        return moment({year: year, month: month - 1, day: day});
    }

    monthAndYearText(month, year, locale) {
        return moment("" + month, 'MM').locale(locale).format('MMMM') + " " + year;
    }

    monthAndYear(month, year) {
        return month < 10 ? "0" + month + "/" + year : month + "/" + year;
    }

}